import React, { Suspense, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";

const Auth0ProviderWithRedirectCallback = ({ children, ...props }) => {
    const navigate = useNavigate();
    const onRedirectCallback = (appState) => {
        navigate((appState && appState.returnTo) || window.location.pathname);
    };
    return (
        <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
            {children}
        </Auth0Provider>
    );
};

const ConditionalApp = () => {
    const { isAuthenticated, loginWithRedirect, isLoading, error } = useAuth0();

    useEffect(
        (appState) => {
            if (!isLoading && !isAuthenticated) {
                loginWithRedirect({
                    appState: {
                        returnTo:
                            appState?.returnTo || window.location.pathname,
                    },
                });
            }
        },
        [isLoading, isAuthenticated, loginWithRedirect],
    );

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return (
            <div>
                An error occured when loading the page, please contact support{" "}
                {error.message}
            </div>
        );
    }
    if (isAuthenticated) {
        return <App />;
    } else {
        return null;
    }
};

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUDIENCE;

const root = createRoot(document.getElementById("root"));
root.render(
    <Router>
        <Suspense fallback="...is loading">
            <Auth0ProviderWithRedirectCallback
                domain={domain}
                clientId={clientId}
                authorizationParams={{
                    redirect_uri: window.location.origin,
                    audience: audience,
                    scope: "openid email profile offline_access",
                }}
                useRefreshTokens={true}
                useRefreshTokensFallback={true}
                cacheLocation="memory"
            >
                <ConditionalApp />
            </Auth0ProviderWithRedirectCallback>
        </Suspense>
    </Router>,
);
